export default __webpack_public_path__ + "7595983ac3ea89d509f81ad998360067.svg";